// extracted by mini-css-extract-plugin
module.exports = {"root":"OffDuties_root__3dGxK","wrapper":"OffDuties_wrapper__r0g--"};